import React, { useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import Slide from '@mui/material/Slide';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const Alerta = ({ tipo, mensaje, estadoAlerta, setAlerta }) => {
  useEffect(() => {
    let tiempo;

    if (estadoAlerta === true) {
      tiempo = setTimeout(() => {
        setAlerta(false);
      }, 4000);
    }

    return () => clearTimeout(tiempo);
  }, [estadoAlerta, setAlerta]);

  return (
    <Snackbar
      open={estadoAlerta}
      TransitionComponent={SlideTransition}
      autoHideDuration={4000}
      onClose={() => setAlerta(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={() => setAlerta(false)} severity={tipo} sx={{ 
        width: '100%', 
        background: '#5d0303',
        border: '2px solid #f9f9f9',
        borderRadius: '4px',
        color: '#f9f9f9',
        position: 'relative'
      }} variant="outlined">
        {mensaje}
      </Alert>
    </Snackbar>
  );
};

export default Alerta;